import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Footer from './components/Footer';
import PaperDigest from './components/PaperDigest';
import PaperInformation from './components/PaperInformation';
import Today from './components/Today';
import Archive from './components/Archive';
import SignIn from './components/SignIn';
import Pricing from './components/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import User from './components/User';
import AIDashboard from './components/AIDashboard';
import AIChats from './components/AIChats';
import AISummaryPage from './components/AISummaryPage';
import { AuthProvider } from './context/AuthContext';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCancel from './components/PaymentCancel';
import ChangeSubscription from './components/ChangeSubscription';
import ErrorPage from './components/ErrorPage';
import MobileNav from './components/MobileNav';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        className="container mx-auto px-4 sm:px-6 py-6 sm:py-10"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.35, ease: [0.25, 0.1, 0.25, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<PaperDigest />} />
          <Route path="/paper/*" element={<PaperInformation />} />
          <Route path="/today" element={<Today />} />
          <Route path="/archive" element={<Archive />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/user" element={<User />} />
          <Route path="/ai" element={<AIDashboard />} />
          <Route path="/ai/chats" element={<AIChats />} />
          <Route path="/ai/chats/:sessionId" element={<AIChats />} />
          <Route path="/ai/summary/:paperId" element={<AISummaryPage />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-cancel" element={<PaymentCancel />} />
          <Route path="/change-subscription" element={<ChangeSubscription />} />
          <Route path="/error" element={<ErrorPage />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-br from-purple-600 via-pink-500 to-red-500 font-code antialiased pb-14 md:pb-0">
          <Header />
          <AnimatedRoutes />
          <Footer />
          <MobileNav />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
